export default __webpack_public_path__ + "static/media/T_Tatu.e6cf9674.svg";